import ProteinSmall from "Images/quiz/upsell/prot.png";
import PreworkoutSmall from "Images/quiz/upsell/prework-w.png";
import Protein from "Images/quiz/upsell/pr.png";
import Preworkout from "Images/quiz/upsell/prw.png";
import Hydration from "Images/quiz/upsell/hy.png";
import Creatine from "Images/quiz/upsell/cr.png";
import Collagen from "Images/quiz/upsell/co.png";
import Fiber from "Images/quiz/upsell/fi.png";
import Greens from "Images/shop/greens_tropicalpineapple_28.png";

export const mockReviews = [
  {
    name: "Lily J.",
    short_name: "LJ",
    rate: 5,
    copy: (
      <div>
        Unlike many other nutrition supplements, Gainful uses{" "}
        <strong>safe and authentic ingredients</strong> that are personalized
        for your needs. Their dieticians are very helpful and provide insightful
        information to help me better understand what I need for my body. I
        highly recommend & support Gainful!
      </div>
    ),
    img: ProteinSmall,
    link: "protein",
    product: "protein",
  },
  {
    name: "Jojo ZZ.",
    short_name: "JZ",
    rate: 5,
    copy: (
      <div>
        The first day I started with Gainful, I could already tell the
        difference in my ability to stay
        <strong>energized & hydrated</strong>. I am a high-intensity indoor
        cycling & HIIT instructor, so I have to keep the energy up 3x a day. I
        felt a difference with the pre-workout powder & protein shake taken
        before my class.
      </div>
    ),
    img: PreworkoutSmall,
    link: "preworkout",
    product: "Pre-Workout",
  },
];

export const productPics = {
  protein: Protein,
  preworkout: Preworkout,
  hydration: Hydration,
  creatine: Creatine,
  collagen: Collagen,
  fiber: Fiber,
  greens: Greens,
};
